/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The drawing area supports touch, so you can sign with your finger on a phone or tablet, then download the PNG.`)
};

const es_sig_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El área de dibujo admite el tacto, por lo que puedes firmar con tu dedo en un teléfono o tableta, luego descargar el PNG.`)
};

const de_sig_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Der Zeichenbereich unterstützt Touch, sodass Sie mit Ihrem Finger auf einem Telefon oder Tablet signieren und dann die PNG herunterladen können.`)
};

const nl_sig_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Het tekengebied ondersteunt aanraking, dus u kunt met uw vinger op een telefoon of tablet ondertekenen en vervolgens de PNG downloaden.`)
};

const fr_sig_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. La zone de dessin prend en charge le tactile, vous pouvez donc signer avec votre doigt sur un téléphone ou une tablette, puis télécharger le PNG.`)
};

const it_sig_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. L'area di disegno supporta il tocco, quindi puoi firmare con il dito su un telefono o tablet, poi scaricare il PNG.`)
};

const pt_br2_sig_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A área de desenho suporta toque, então você pode assinar com seu dedo em um telefone ou tablet, depois baixar o PNG.`)
};

const pt_sig_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A área de desenho suporta toque, portanto pode assinar com o dedo num telemóvel ou tablet, depois descarregar o PNG.`)
};

const ja_sig_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。描画エリアはタッチをサポートしているため、スマートフォンまたはタブレットで指で署名してから、PNGをダウンロードできます。`)
};

const zh_sig_hub_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。绘制区域支持触摸，因此您可以在手机或平板电脑上用手指签名，然后下载 PNG。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_hub_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_hub_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_hub_faq3_a", locale)
	if (locale === "en") return en_sig_hub_faq3_a(inputs)
	if (locale === "es") return es_sig_hub_faq3_a(inputs)
	if (locale === "de") return de_sig_hub_faq3_a(inputs)
	if (locale === "nl") return nl_sig_hub_faq3_a(inputs)
	if (locale === "fr") return fr_sig_hub_faq3_a(inputs)
	if (locale === "it") return it_sig_hub_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_sig_hub_faq3_a(inputs)
	if (locale === "pt") return pt_sig_hub_faq3_a(inputs)
	if (locale === "ja") return ja_sig_hub_faq3_a(inputs)
	return zh_sig_hub_faq3_a(inputs)
};